<template>
  <div>
    <div class="handle-box">

      <el-button type="primary" icon="el-icon-plus" @click="addRule">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="ID" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="等级名称" width="200" show-overflow-tooltip
        header-align="center"></el-table-column>
      <el-table-column prop="desc" label="描述" show-overflow-tooltip></el-table-column>
      <el-table-column prop="num" label="该类用户数量">
        <template #default="scope">
          <el-button type="text" @click="getTheUserList(scope.row.users, scope.row.name)">{{
            scope.row.users ? scope.row.users.length : 0 }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!(scope.row.status == 1) ? 'red' : '']">
            {{ scope.row.status == 1 ? "启用" : "禁用" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="CreatedAt" label="创建日期" show-overflow-tooltip header-align="center"
        :formatter="dateRfcHMS"></el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="editRule(scope.row)">编辑
          </el-button>
          <el-button type="text" style="color: red;" @click="deleteRule(scope.row.ID)" icon="el-icon-delete">删除
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog v-model="editVisible" :title="[form.code ? '编辑' : '添加'] + '用户等级'" @close="editVisible = false"
      :width="750">
      <div class="edit-container">
        <el-form ref="form" :model="form" :rules="rules" label-width="130px">
          <el-form-item prop="name" label="名称：">
            <el-input v-model="form.name" :disabled="actTitle == '编辑'" placeholder="请输入等级名称"></el-input>
          </el-form-item>
          <el-form-item prop="users" label="已选用户：">
            <el-button type="primary" @click="showUserList(userList, form.name)"
              class="mr10">选择用户</el-button><span>已选择（{{
                userList.length }}）人</span>
            <div class="select-user-box" v-if="userList && userList.length > 0">
              <div class="select-user-item">
                <div>ID</div>
                <div>客户</div>
                <div>手机号</div>
                <!-- <div>是否有效</div> -->
              </div>
              <div v-for="(item, index) in userList" :key="index" class="select-user-item">

                <div>{{ item.id }}</div>
                <div>{{ item.real_name || item.nickname }}</div>
                <div>{{ item.phone }}</div>
                <!-- <div>{{ item.is_validate ? '有效' : '无效' }}</div> -->
              </div>
            </div>
            <div v-else>暂未选择</div>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input type="textarea" v-model="form.desc" placeholder="请输入描述" style="height: 100px;"
              resize="none"></el-input>
          </el-form-item>
          <el-form-item prop="status" label="是否启用：">
            <el-switch v-model="form.status"></el-switch>
          </el-form-item>
          <div style="text-align: right; margin-top: 10px">
            <el-button @click="editVisible = false">取消</el-button>
            <el-button type="primary" @click="saveEdit">保存</el-button>
          </div>
        </el-form>
      </div>

    </el-dialog>
    <el-dialog :title="userNum" v-model="userVisible" width="70%" height="70vh">
      <div class="handle-box">
        <el-input v-model="user_query.real_name" placeholder="客户称呼" class="handle-input mr10"></el-input>
        <el-input v-model="user_query.nickname" placeholder="昵称" class="handle-input mr10"></el-input>
        <el-input v-model="user_query.phone" placeholder="客户手机号" class="handle-input mr10"></el-input>

        <el-select v-model="user_query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
          <el-option key="1" label="有效" value="1"></el-option>
          <el-option key="2" label="无效" value="0"></el-option>
        </el-select><el-button type="primary" icon="el-icon-search" @click="handleSearch()" class="mr10">搜索</el-button>
      </div>

      <el-table :data="userData" border class="table" ref="multipleTable2" header-cell-class-name="table-header"
        :cell-style="centerStyle" @select="handleSelectionChange" @select-all="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="ID" label="ID" width="55" align="center">
          <template #default="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称呼" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.real_name || scope.row.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="头像" prop="avatar" align="center" width="100">
          <template #default="scope">
            <el-image v-if="scope.row.avatar" class="table-td-thumb" :src="scope.row.avatar"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center" width="100">
          <template #default="scope">
            {{ sexMap.get(scope.row.sex) }}
          </template>
        </el-table-column>
        <el-table-column label="余额" align="right">
          <template #default="scope">
            <el-button type="text" :style="'color:#409EFF'">
              {{ (scope.row.balance_total / 100).toFixed(2) }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="积分" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:#409EFF'">
              {{ scope.row.score_total }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="累计消费" align="center">
          <template #default="scope">
            {{ (scope.row.consume_total / 100).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="是否有效" width="100" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="c_at" :formatter="dateFormat" align="center" label="添加时间"
          width="200px;"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleUserSizeChange" @current-change="handleUserChange"
          :current-page="user_query.page" :page-sizes="[10, 20, 50, 100, 200]" :page-size="user_query.page_size"
          layout="total,sizes, prev, pager, next" :total="userPageTotal">
        </el-pagination>
      </div>
      <div style="text-align: right; margin-top: 10px">
        <el-button type="primary" @click="saveSelect">确认选择</el-button>
      </div>
    </el-dialog>
    <el-dialog title="用户列表" v-model="typeUserVisible" width="50%" height="70vh">
      <el-table :data="typeUserList" border class="table" ref="multipleTable2" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column prop="ID" label="ID" width="55" align="center">
          <template #default="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="称呼" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.real_name || scope.row.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="手机号码" width="200" show-overflow-tooltip header-align="center">
          <template #default="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomizeRulesList, createCustomizeRule, updateCustomizeRule, deleteCustomizeRule } from "../api/user_rules";
import { getUserList } from "../api/user";
export default {
  name: "CustomizeUser",
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        minQuantity: [{ required: true, message: '请输入最低下单量', trigger: 'blur' }],
        maxQuantity: [{ required: true, message: '请输入最高下单量', trigger: 'blur' }],
        month: [{ required: true, message: '请选择统计单位', trigger: 'change' }]
      },
      tableData: [{
        ID: 1
      }],
      pageTotal: 0,
      form: {
        id: 0,
        status: 1, //规则状态（1-启用，2-停用）
        name: '', //规则名称
        desc: '', //规则描述
        users: []
      },
      actTitle: "新增", // 弹框标题
      editVisible: false, // 弹框开启状态
      userList: [],
      rule_query: {
        page: 1,
        pageSize: 10,
        // CustomizeRuleId: null
      },
      userPageTotal: 0,
      userNum: '用户列表（已选0人）',
      userVisible: false,
      user_query: {
        nickname: "",
        real_name: '',
        phone: "",
        is_validate: null,
        page: 1,
        page_size: 10
      },
      userData: [],
      sexMap: new Map(),
      sex: [
        {
          text: '未知',
          value: 0
        },
        {
          text: '男',
          value: 1
        },
        {
          text: '女',
          value: 2
        }
      ],
      selectUser: [],
      typeUserList: [],
      typeUserVisible: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    dateRfcHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return new Date(+new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    },

    centerStyle() {
      return 'text-align:center'
    },
    getData() {
      this.tableData = []
      getCustomizeRulesList(this.query).then(res => {
        this.tableData = res.data.list
        this.pageTotal = res.data.total
      })
    },
    // 获取所有的用户列表
    getUserData() {
      getUserList(this.user_query).then(res => {
        this.userData = JSON.parse(JSON.stringify(res.data))
        this.userData.forEach(item => {
          if (item.nickname == '') {
            item.nickname = '未知'
          }
          const index = this.userList.findIndex(user => user.id === item.id);
          if (index !== -1) {
            this.userList[index] = item;
          }
          this.sex.forEach(item => {
            this.sexMap.set(item.value, item.text)
          })
          if (item.avatar == '') {
            item.avatar = 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'
          }
          if (res.count) {
            this.userPageTotal = res.count
          }
        })
        if (this.$refs.multipleTable2) {
          const commonItems = this.userData.filter(item => {
            return this.selectUser.some(user => user.id === item.id);
          });
          this.toggleSelection(commonItems)
        }


      })
    },

    handleSelectionChange(val, row) {
      if (row) {
        const index = this.selectUser.findIndex(user => user.id === row.id);
        if (index !== -1) {
          // 如果存在，从 this.selectUser 中删除
          this.selectUser.splice(index, 1);
        }
      }
      if (val && val.length > 0) {
        val.forEach(item => {
          const index = this.selectUser.findIndex(user => user.id === item.id);
          if (index === -1) {
            this.selectUser.push(item);
          }else if(index!= -1){
            this.selectUser.splice(index,1);
          }
        });
      } else {
        this.userData.forEach(item => {
          const index = this.selectUser.findIndex(user => user.id === item.id);
          if (index != -1) {
            this.selectUser.splice(index,1);
          }
        })
      }
    },

    // 触发搜索按钮
    handleSearch() {
      this.getUserData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    // 用户列表分页导航
    handleUserChange(val) {
      this.user_query.page = val
      this.getUserData()

    },
    handleUserSizeChange(val) {
      this.user_query.page_size = val
      this.getUserData()
    },

    // 添加弹框
    addRule() {
      this.form = {}
      this.actTitle = "新增"
      this.form.id = null
      this.editVisible = true
    },

    // 编辑弹框
    editRule(row) {
      this.actTitle = "编辑"
      this.userList = row.users
      this.selectUser = JSON.parse(JSON.stringify(this.userList))
      this.form.id = row.ID
      this.form.name = row.name
      this.form.desc = row.desc
      this.form.status = row.status == 1 ? true : false
      this.getUserData()
      this.editVisible = true

    },
    toggleSelection(rows) {
      this.$nextTick(() => {
        let that = this
        if (rows) {
          rows.forEach(row => {
            that.$refs.multipleTable2.toggleRowSelection(row, true);
          });
        } else {
          this.$refs.multipleTable2.clearSelection();
        }
      })

    },
    showUserList(users, name) {
      this.userTypeName = name
      this.userVisible = true
      this.userList = users
      this.userNum = this.userTypeName + '（总' + users.length + '人）'
      this.toggleSelection(this.userList)
    },
    getTheUserList(users) {
      this.typeUserList = users
      this.typeUserVisible = true
    },
    saveEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let users = []
        this.form.status = this.form.status ? 1 : 2
        this.userList.forEach(item => {
          users.push({ id: item.id })
        })
        this.form.users = users
        if (!!this.form.id && this.form.id != 0) {
          updateCustomizeRule(JSON.stringify(this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.editVisible = false
              this.getData()
            }
          })
        } else {
          this.form.status = this.form.status ? 1 : 2
          createCustomizeRule(JSON.stringify(this.form)).then(res => {
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.editVisible = false
              this.getData()
            }
          })
        }
      })
    },

    // 删除活动
    deleteRule(id) {
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteCustomizeRule(JSON.stringify({ id })).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })
    },
    saveSelect() {
      this.userList = this.selectUser
      this.userVisible = false
    },
  }
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.select-user-box {
  max-height: 300px;
  overflow-y: scroll;
  padding: 20px;
}

.handle-input {
  width: 100px;
  display: inline-block;
  margin-bottom: 10px;
}

.mr10 {
  margin-right: 10px;
}

.el-input,
.el-input-number {
  width: 220px;
  margin-right: 10px;
}

.el-select {
  width: 220px;
}

.el-dialog__body .edit-container .el-select,
.el-dialog__body .edit-container .el-input,
.el-dialog__body .edit-container .el-input-number,
.el-dialog__body .edit-container .el-textarea {
  width: 80% !important;
  text-align: left;
}

.box {
  margin: 0 auto;
}

.box .el-input {
  width: 60%;
}

.rowstyle {
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip {
  font-size: 12px;
  color: red;
}

.w350 {
  width: 350px;
}

.w250 {
  width: 250px;
}

.table-td-thumb {
  width: 30px;
  height: 30px;
}

.select-user-item {
  width: 80%;
  display: flex;
  justify-content: space-between;
}

.select-user-item div {
  width: 30%;
  text-align: left;
}
</style>